import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Select, Spin } from "antd";
import Swal from "sweetalert2";
import {
  getApiBaseUrl,
  UPDATE_EQUIP,
  ADD_ACTIVITY,
  GET_BLOCKS,
} from "../../Config/Config";

const { Option } = Select;

const EditWashingEquip = ({ editObj }) => {
  const [formData, setFormData] = useState({
    Id: editObj?.Id,
    EquipmentName: editObj?.EquipmentName || "",
    SerialNumber: editObj?.SerialNumber || "",
    Isdryer: 0,
    blockid: editObj?.BlockId || null,
  });

  useEffect(() => {
    if (editObj && editObj.Id) {
      setFormData({
        Id: editObj.Id,
        EquipmentName: editObj.EquipmentName || "",
        SerialNumber: editObj.SerialNumber || "",
        Isdryer: editObj.Isdryer ? 1 : 0,
        blockid: editObj.BlockId || null,
      });
      setSelectedBlock(editObj.BlockId || null);
    }
  }, [editObj]);
  console.log(formData, "jjjjjjjjjjjjj");
  const [blockOptions, setBlockOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedBlock, setSelectedBlock] = useState(null);

  const fetchBlocks = async () => {
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_BLOCKS}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      const blocks = result?.ResultData || [];
      setBlockOptions(blocks);
    } catch (err) {
      console.error("Failed to fetch blocks:", err);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, []);
  const handleBlockChange = (value) => {
    setSelectedBlock(value);
    setFormData((prev) => ({
      ...prev,
      blockid: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = name === "Isdryer" ? parseInt(value, 10) : value;

    setFormData((prev) => ({
      ...prev,
      [name]: parsedValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const userId = JSON.parse(sessionStorage.getItem("user"))?.UserID;

    const payload = {
      Id: formData.Id,
      EquipmentName: formData.EquipmentName,
      SerialNumber: formData.SerialNumber,
      Isdryer: 0,
      blockid: formData.blockid,
      UpdatedBy: userId,
    };

    const logActivity = async (isSuccess, note) => {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 2, // assuming 2 = Update, adjust if needed
            PerformedBy: userId,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: note,
            Location: "Update Wash Equipment",
            IsSucces: isSuccess ? 1 : 0,
          }),
        });
      } catch (err) {
        console.error("Activity logging failed:", err);
      }
    };

    try {
      const response = await fetch(`${getApiBaseUrl()}${UPDATE_EQUIP}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      setLoading(false);

      const msg = result?.ResultData?.[0]?.ResultMessage;

      if (msg?.toLowerCase().includes("success")) {
        await logActivity(
          true,
          `Wash Equipment updated: ${formData.EquipmentName || ""}`
        );
        Swal.fire({
          icon: "success",
          title: "Updated",
          text:`Wash Equipment updated: ${formData.EquipmentName || ""}`,
        }).then(() => {
          window.location.reload();
        });
      } else {
        await logActivity(
          false,
          `Update failed: ${msg || "API returned failure."}`
        );
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: msg || "Something went wrong while updating.",
        });
      }
    } catch (error) {
      setLoading(false);
      await logActivity(false, `Update error: ${error.message}`);
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Failed to send update request.",
      });
    }
  };

  return (
    <>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="EditWashingEquipOffcanvas"
      >
        <form onSubmit={handleSubmit}>
          <div className="offcanvas-header">
            <h5 className="offcanvas-title me-4">Edit Washing Equipment</h5>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <div className="offcanvas-body">
            <div className="mb-3">
              <label className="form-label">Equipment Name</label>
              <input
                type="text"
                className="form-control"
                name="EquipmentName"
                value={formData.EquipmentName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Serial Number</label>
              <input
                type="text"
                className="form-control"
                name="SerialNumber"
                value={formData.SerialNumber}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label ">Block</label>
              <Select
                showSearch
                placeholder="Select a Block"
                optionFilterProp="children"
                onChange={handleBlockChange}
                value={selectedBlock}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
                aria-required
              >
                {blockOptions.map((block) => (
                  <Option key={block.BlockId} value={block.BlockId}>
                    {block.BlockName}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

EditWashingEquip.propTypes = {
  editObj: PropTypes.object,
};
export default EditWashingEquip;
